import { startAuthentication, startRegistration, browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from "@simplewebauthn/browser";
import { api } from "@/lib/api";

const FLAG = "nt_passkey";
export const hasLocalPasskey = () => localStorage.getItem(FLAG) === "1";
export const passkeyAvailable = async () => browserSupportsWebAuthn() && (await platformAuthenticatorIsAvailable().catch(() => false));

const device = () => {
  const ua = navigator.userAgent;
  const os = /iPhone|iPad/.test(ua) ? "iPhone / iPad" : /Android/.test(ua) ? "Android phone" : /Mac/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows PC" : "Device";
  const br = /Edg\//.test(ua) ? "Edge" : /SamsungBrowser/.test(ua) ? "Samsung Internet" : /CriOS|Chrome\//.test(ua) ? "Chrome" : /Firefox|FxiOS/.test(ua) ? "Firefox" : /Safari/.test(ua) ? "Safari" : "";
  return br ? `${br} on ${os}` : os;
};

const friendly = (e) => {
  if (e?.name === "NotAllowedError") return new Error("Cancelled or timed out. Please try again.");
  if (e?.name === "InvalidStateError") return new Error("This device is already registered.");
  return e;
};

export async function registerPasskey() {
  const { data } = await api.post("/passkeys/register/options");
  let credential;
  try { credential = await startRegistration({ optionsJSON: data.options }); } catch (e) { throw friendly(e); }
  await api.post("/passkeys/register/verify", { flow_id: data.flow_id, credential, device: device() });
  localStorage.setItem(FLAG, "1");
}

export async function loginPasskey(remember) {
  const { data } = await api.post("/passkeys/login/options");
  let credential;
  try { credential = await startAuthentication({ optionsJSON: data.options }); } catch (e) { throw friendly(e); }
  let res;
  try { res = await api.post("/passkeys/login/verify", { flow_id: data.flow_id, credential, remember }); }
  catch (e) { if (e?.response?.status === 401) localStorage.removeItem(FLAG); throw e; }
  localStorage.setItem(FLAG, "1");
  return res.data.user;
}

export const forgetLocalPasskey = () => localStorage.removeItem(FLAG);
